import React from 'react';
import './Toast.less';

export interface ToastInfo {
    id: string;
    text: string;
    mask: boolean;
    duration: number;
}

export interface ToastPropType {
    info: ToastInfo;
    onClose: (id, type) => void;
    prefixCls?: string;
}

class Toast extends React.Component<ToastPropType> {
    static defaultProps = {
        prefixCls: 'toast'
    };

    time: any;

    componentDidMount() {
        const {info, onClose} = this.props;
        clearTimeout(this.time);
        this.time = setTimeout(() => {
            if (onClose) {
                onClose(info.id, 'toast');
            }
        }, info.duration);
    }

    componentWillUnmount() {
        clearTimeout(this.time);
    }

    render() {
        const {info, prefixCls} = this.props;
        let style: any = {};
        if (!info.mask) {
            style.pointerEvents = 'none';
        }

        return <div className={prefixCls} style={style}>
            <div className={`${prefixCls}-wrapper`}>
                {info.text}
            </div>
        </div>;
    }
}

export default Toast;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/notice/Toast.tsx